import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { getControlField } from "../../../../Services/tooltipService";
import { all } from "../../../../Services/userService";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import { statusUpdate } from "../../../../Services/userService";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import { Dialog } from "primereact/dialog";

const UserClassification = (props) => {
    const [customerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controlPanelTabs, setControlPanelTabs] = useState({});
    const [cntlPannelUserclasification, setCntlPannelUserclasification] = useState('');
    const [controlPannelUserClassHeaders, setControlPannelUserClassHeaders] = useState([]);
    const [controlPannelUserTableHeaders, setControlPannelUserTableHeaders] = useState([]);
    const [userList, setUserList] = useState([]);
    const [filterUserList, setFilterUserList] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0
    });
    const [updatedUsers, setUpdatedUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const [branchData, setBranchData] = useState(null)
    const [showVideo, setShowVideo] = useState(false);
    const toastRef = useRef()
    const navigate = useNavigate()
    useEffect(() => {
        const customerData = localStorage.getItem("enduser");
        if (customerData) {
            const customerDataInJSON = JSON.parse(customerData);
            setCustomerId(customerDataInJSON.customer);
            setBranchData(customerDataInJSON.branch)
        }else {
            navigate("/login")
            localStorage.clear()
          }
    }, []);

    useEffect(() => {
        if (customerId) {
            getControlFieldData();
            allUser();
        }
    }, [customerId]);

    const getControlFieldData = async () => {
        try {
            if (customerId === null) {
                return;
            }
            var clientModuleData = await getControlField(customerId)
            var controlPanelModules = _.find(clientModuleData?.data?.cust[0].modules, { module_name: "Control Panel", status: true });
            var controlPanelTabs = _.find(controlPanelModules.tabs, { tab_name: "User Classification", status: true });
            setControlPanelTabs(controlPanelTabs)

            var cntlPannel_User = _.find(controlPanelModules.tabs, { tab_name: "User Classification" }).tables;
            var ControlPannelUserClassHeaders = _.find(cntlPannel_User, { table_name: "User Classification" }).headers;
            setControlPannelUserClassHeaders(ControlPannelUserClassHeaders)
            var cntlPannelUserclasification = _.find(controlPanelModules.tabs, { tab_name: "User Classification" }).display_name;
            setCntlPannelUserclasification(cntlPannelUserclasification)

            var ControlPannelUserTableHeaders = _.find(cntlPannel_User, { table_name: "User Classification" }).display_name;
            setControlPannelUserTableHeaders(ControlPannelUserTableHeaders)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const allUser = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            const userResponse = await all(customerId, "firstname", 1, branchData);
            setUserList(userResponse?.data)
            setFilterUserList(userResponse?.data)
            setTotalRecords(userResponse?.data?.count);
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    }

    const textEditor = (rowData) => {
        return <DropdownElement
            value={rowData.rowData.status}
            onChange={(e) => rowData.editorCallback(e.value)}
            options={[
                { label: 'Active', value: 'active' },
                { label: 'Inactive', value: 'inactive' },
                { label: 'Left the company', value: 'left the company' }
            ]}
            optionLabel="label"
            placeholder="-- Please select --"
            className="w-full"
        />
    };

    const handleStatusChange = (selectedOpp) => {
        var username = selectedOpp.username;
        var status = selectedOpp.status;
        // Update the array with the new status for the user
        setUpdatedUsers(prevState => {
            // Check if the user already exists in the array
            const existingUserIndex = prevState.findIndex(user => user.username === username);

            if (existingUserIndex !== -1) {
                // Update the existing user's status
                const updatedArray = [...prevState];
                updatedArray[existingUserIndex].status = status;
                return updatedArray;
            } else {
                // Add the new user and their status
                return [...prevState, { username, status }];
            }
        });

        setUserList(prevUserList => {
            const userIndex = prevUserList.findIndex(user => user.username === username);
            if (userIndex !== -1) {
                const updatedUserList = [...prevUserList];
                updatedUserList[userIndex] = { ...updatedUserList[userIndex], status };
                return updatedUserList;
            }
            return prevUserList;
        });

    };

    const filteredQuestionsArray = (query) => {
        const lowerCaseQuery = query.toLowerCase();
        if (lowerCaseQuery.length === 0) {
            allUser();
            setSearchedLength(lowerCaseQuery.length);
        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }
            // const filteredData = filterUserList.filter(item => {
            //     return Object.values(item).some(value => {
            //         if (value != null) {
            //             return value.toString().toLowerCase().includes(lowerCaseQuery);
            //         }
            //     });
            // });
            const filteredData = filterUserList.filter(item => {
                return (
                    (item.firstname && item.firstname.toString().toLowerCase().includes(lowerCaseQuery)) ||
                    (item.surname && item.surname.toString().toLowerCase().includes(lowerCaseQuery)) ||
                    (item.username && item.username.toString().toLowerCase().includes(lowerCaseQuery)) ||
                    (item.status && item.status.toString().toLowerCase().includes(lowerCaseQuery))
                );
            });
            setUserList(filteredData)
        }
    }

    const handleSubmit = async () => {
        if (updatedUsers.length > 0) {
            try {
                setLoading(true)
                const response = await statusUpdate(updatedUsers);
                if (response && response?.status === 200) {
                    toastRef.current.showToast({
                        type: "success",
                        message: `${cntlPannelUserclasification} Status Updated Successfully`,
                    });
                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: "Error",
                    });
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'An error occurred. Please try again or Contact Admin.'
                });
            } finally {
                setLoading(false)
            }
        } else {
            toastRef.current.showToast({
                type: "warning",
                message: "No User Status has been changed",
            });
            setLoading(false)
        }
    };


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        filteredQuestionsArray(e.target.value)
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        filteredQuestionsArray("");
    };

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };


    const columns = [
        {
            field: "index",
            header: _.find(controlPannelUserClassHeaders, { header_name: "#" })?.display_name,
            headerClassName: "header-datatable white-space",
            body: (rowData, { rowIndex }) => rowIndex + 1,
            className: 'row-datatable',
            style: { width: '5%' }
        },
        {
            field: "firstname",
            header: _.find(controlPannelUserClassHeaders, { header_name: "First Name" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            style: { width: '20%' }
        },
        {
            field: "surname",
            header: _.find(controlPannelUserClassHeaders, { header_name: "Last Name" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            style: { width: '20%' }
        },
        {
            field: "username",
            header: _.find(controlPannelUserClassHeaders, { header_name: "User Name" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            style: { width: '25%' }
        },
        {
            field: "status",
            header: _.find(controlPannelUserClassHeaders, { header_name: "Status" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            editor: textEditor,
            style: { width: '20%' }
        }
    ]

    const handleButtonClick = () => {
        setShowVideo(true);
      };
    
      const closeVideo = () => {
          setShowVideo(false);
      };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col pr-0 pl-0">
                    <p className="label-text">
                        {controlPanelTabs?.display_name}
                    </p>
                    <p className="group-table-text-section">
                        Please adjust the status of each user
                    </p>
                </div>
                <div className="col pr-0 d-flex justify-end">
					<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
				</div>
            </div>
            <div className="group-table-buttons mt-0">
                <div className="delete-button"></div>
                <div className="group-table-search">
                    <HeaderSearchBar
                        value={searchQuery}
                        onChange={(e) => handleSearchChange(e)}
                        onClick={handleClearFilter}
                    />
                </div>
            </div>
            <div className="data-submit">
                <DataTable
                    value={userList}
                    columns={columns}
                    dataKey="_id"
                    isRowEditorUserClass={true}
                    rowEditClick={handleStatusChange}
                    onPage={onPage}
                    lazyParams={lazyParams}
                    totalRecords={totalRecords}
                    header={controlPannelUserTableHeaders}
                />
            </div>
            {
                <div className="col pr-0 d-flex justify-end">
                    <ButtonElement className="save-button" type="submit" onClick={handleSubmit} label="Submit" />
                </div>
            }
            <Dialog id="videoModal" visible={showVideo}
				breakpoints={{
				'1200px': '80vw',    // Larger modal on bigger screens
				'1024px': '85vw',    // Slightly smaller for medium screens
				'769': '90vw',     // Responsive on tablets
				'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_user_class" />
					</div>
				</div>
			</Dialog>
        </div>
        
    )
}

export default UserClassification;
